import { Component, EventEmitter, Inject, OnInit, Output } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-json-mapping-field-dialog',
  templateUrl: './json-mapping-field.dialog.html',
  styleUrls: ['./json-mapping-field.dialog.scss'],
  standalone: false,
})
export class JSONMappingFieldDialog implements OnInit {
  @Output() onSave = new EventEmitter();

  title: string;
  rows: Array<{ key: string; value: string; additionalValue?: string }> = [];
  defaultMappings: Array<{ key: string; value: string; additionalValue?: string }> = [];
  options: Array<{ name: string; value: string }> = [];
  additionalValueOptions: Array<{ name: string; value: string }> = [];
  newKey: string = '';
  newValue: string = '';
  newFreeTextValue: string = '';
  additionalValue: string = '';
  newKeyPlaceholder: string = 'Enter key name';
  showNewKeyRequiredError: boolean = false;
  freeTextSupport: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<JSONMappingFieldDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  ngOnInit() {
    this.title = this.data.title;
    this.options = this.data.options;
    this.newValue = this.options[0].value;

    if (this.data.newKeyPlaceholder) {
      this.newKeyPlaceholder = this.data.newKeyPlaceholder;
    }

    if (this.data.additionalValueOptions) {
      this.additionalValueOptions = this.data.additionalValueOptions;
      this.additionalValue = this.additionalValueOptions[0].value;
    }
    if (this.data.freeTextSupport) {
      this.addCustomOption = this.addCustomOption.bind(this);
      this.freeTextSupport = this.data.freeTextSupport;
    }

    try {
      const valueObject = JSON.parse(this.data.value);
      const valueKeys = Object.keys(valueObject);
      valueKeys.forEach((key) =>
        this.rows.push({
          key,
          value: this.getOptionValue(valueObject[key]),
          additionalValue: this.getAdditionalValue(valueObject[key]),
        }),
      );
    } catch (error) {
      console.log(error);
      this.rows = [];
    }

    if (this.data.defaultMappings) {
      this.defaultMappings = this.data.defaultMappings.map((key) => {
        const existingMappingIndex = this.rows.findIndex((row) => row.key === key);
        let value = this.options[0].value;
        let additionalValue = this.additionalValueOptions[0].value;
        if (existingMappingIndex >= 0) {
          value = this.rows[existingMappingIndex].value;
          additionalValue = this.rows[existingMappingIndex].additionalValue;
          this.rows.splice(existingMappingIndex, 1);
        }
        return { key, value, additionalValue };
      });
      // .filter((mapping) => mapping.value);
    }
  }

  onAddHandler(): void {
    if (this.additionalValue && this.newKey) {
      this.rows.push({ key: this.newKey, value: this.newValue, additionalValue: this.additionalValue });
      this.showNewKeyRequiredError = false;
    } else if (this.newKey) {
      this.rows.push({ key: this.newKey, value: this.newValue });
      this.showNewKeyRequiredError = false;
    } else {
      this.showNewKeyRequiredError = true;
    }

    this.newKey = '';
    this.newValue = this.options[0].value;
  }

  onDeleteHandler(index): void {
    this.rows.splice(index, 1);
  }

  onDeleteDefaultMappingHandler(index): void {
    this.defaultMappings.splice(index, 1);
  }

  onCloseHandler(): void {
    this.dialogRef.close();
  }

  onSaveHandler(): void {
    try {
      const valueObject = this.rows.reduce((acc, row) => {
        if (row.additionalValue) {
          row.value += '|' + row.additionalValue;
        }
        acc[row.key] = row.value;
        return acc;
      }, {});

      this.defaultMappings.forEach((defaultMapping) => {
        if (defaultMapping.additionalValue) {
          defaultMapping.value += '|' + defaultMapping.additionalValue;
        }
        valueObject[defaultMapping.key] = defaultMapping.value;
      });

      if (!this.defaultMappings.length && this.data.defaultMappings?.length) {
        this.data.defaultMappings.forEach((defaultMappingKey) => {
          valueObject[defaultMappingKey] = null;
        });
      }

      if (this.rows.length) {
        this.onSave.emit(JSON.stringify(valueObject));
      } else {
        this.onSave.emit('');
      }

      this.dialogRef.close();
    } catch (error) {
      console.log(error);
      this.dialogRef.close();
    }
  }

  getOptionNameByValue(value: string) {
    return this.options?.find((option) => option.value === value)?.name || '';
  }
  addCustomOption(name: string) {
    const newOption = { value: name, name };
    this.options = [...this.options, newOption];
    this.newValue = newOption.value;
    return this.newValue;
  }

  getOptionValue(value: string) {
    return value.split('|')[0];
  }

  getAdditionalValue(value: string) {
    return value.split('|')[1];
  }
}
